import axios from "axios";

const configuredBackendUrl = (process.env.REACT_APP_BACKEND_URL || "").trim().replace(/\/+$/, "");
const BACKEND_URL = configuredBackendUrl || (process.env.NODE_ENV === "development" ? "http://localhost:8000" : "");
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API, withCredentials: true });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("falcom_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const fileUrl = (storagePath) => {
  const token = localStorage.getItem("falcom_token");
  return `${API}/files/${storagePath}?auth=${token}`;
};

export async function downloadFile(storagePath, filename) {
  return downloadApiFile(`/files/${storagePath}`, filename);
}

export async function downloadApiFile(endpoint, filename) {
  const res = await api.get(endpoint, { responseType: "blob" });
  const url = URL.createObjectURL(res.data);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename || "download";
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export function formatUploadError(error) {
  const detail = error?.response?.data?.detail;
  if (detail != null) return formatApiErrorDetail(detail);
  if (error?.response?.status === 413) {
    return "Upload ditolak karena batas ukuran di server. Coba file lebih kecil atau hubungi administrator.";
  }
  return formatApiErrorDetail(detail);
}

export default api;
